export const { observeIO, unobserveIO } = (() => {
	let doms = []
	let cbs = []

	const io = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			const cb = cbs[doms.indexOf(entry.target)]
			cb && cb(entry)
		})
	})

	return {
		observeIO: (dom, cb) => {
			doms.indexOf(dom) < 0 && io.observe(dom)
			doms.indexOf(dom) < 0
				? (doms.push(dom), cbs.push(cb))
				: (cbs[doms.indexOf(dom)] = cb)
		},
		unobserveIO: dom => {
			io.unobserve(dom)
			const index = doms.indexOf(dom)
			index >= 0 && (doms.splice(index, 1), cbs.splice(index, 1))
		}
	}
})()